<template>
  <q-footer class="bg-dark q-px-xl q-py-lg">
    <div class="q-gutter-lg q-px-xs-xs q-px-md-xl q-py-lg row justify-xs-start justify-sm-center">
      <!-- <div class="row q-gutter-xl full-width"> -->

      <div col-xs-12 col-sm-4>
        <q-toolbar-title>
          <div class="text-subtitle1 text-uppercase">help</div>
          <div class="text-caption">call: 08123456789</div>
          <div class="text-caption">email: cs@dast.co</div>
        </q-toolbar-title>
      </div>
      <q-space />
      <div col-xs-12 col-sm-4>
        <q-toolbar-title>
          <div class="text-subtitle1 text-uppercase">follow us on</div>
          <div class="q-gutter-md q-mb-xs" style="font-size: 1.2em">
            <q-icon name="mdi-instagram" style="cursor: pointer" />
            <q-icon name="mdi-facebook" style="cursor: pointer" />
            <q-icon name="mdi-twitter" style="cursor: pointer" />
          </div>
          <div class="text-caption">@dast.co</div>
        </q-toolbar-title>
      </div>
      <q-space />
      <div col-xs-12 col-sm-4>
        <q-toolbar-title>
          <div class="text-subtitle1 text-uppercase">store location</div>
          <div class="text-body1">dast.co Concept Store</div>
          <div class="text-caption">Jl. Sriwijaya 1, Desa Haylen, Kecamatan Madripoor</div>
          <div class="text-caption">Pulau Madripoor, Indonesia</div>
        </q-toolbar-title>
      </div>
    </div>
    <!-- </div> -->
    <q-toolbar class="text-center">
      <q-toolbar-title class="text-body2">
        <div class="gt-sm">
          © copyright 2021 dast.co | built with ❤️ by
          <a href="https://github.com/anggidast" target="_blank" rel="noopener noreferrer" class="text-white">Anggidast</a>
        </div>
        <div class="lt-sm">
          <p>© copyright 2021 dast.co</p>
          <p>built with ❤️ by <a href="https://github.com/anggidast" target="_blank" rel="noopener noreferrer" class="text-white">Anggidast</a></p>
        </div>
      </q-toolbar-title>
    </q-toolbar>
  </q-footer>
</template>

<script>
export default {};
</script>

<style></style>
